module.exports = __webpack_public_path__ + "img/icon_boleto_calendar.58c63db6.svg";